const AllTours = Object.freeze({
  resumeBuilderTour: "RESUME_BUILDER_TOUR",
  profilePageTour: "PROFILE_PAGE_TOUR",
  videoPageTour: "VIDEO_PAGE_TOUR",
  welcomeTour: "WELCOME_TOUR",
  batchTour: "BATCH_TOUR",
});

export default AllTours;
